import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const RestrictedSpace: LoadableType<any> = LoadableAfterPaint<any>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RestrictedSpace" */ '../src/RestrictedSpace.tsx'))
			.RestrictedSpace,
});
